module.exports = __webpack_public_path__ + "img/ma267.65800bce.png";